import { ReactElement, useEffect, useState } from 'react';
import Modal from 'react-modal';

import './functionaryForm.css';
import { z } from 'zod';

import { useIncludeFunctionaryForm } from '../../../../../contexts/IncludeFunctionaryFormProvider';
import { useBoostedPlanDataStore } from '../../../../../stores/useBoostedPlanDataStore';
import {
  useDependentIdStore,
  useDependentOpenModalDataStore,
  useDependentShowStore,
} from '../../../../../stores/useDependentStore';
import { calculaIdade } from '../../../../../utils/calculaIdade';
import { Button } from '../../../../Button';
import { SaveIcon } from '../../../../icons/SaveIcon';
import { Input } from '../../../../Input';
import { Select } from '../../../../Select';
import { dependenteSchema } from '../../../Bussiness-steps/data/schema/functionarysSchema';

function validateDependent(obj: any): boolean {
  try {
    dependenteSchema.parse(obj);
    return true;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return false;
    }
    return false;
  }
}

Modal.setAppElement('#root');

export function DependentForm(): ReactElement {
  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    watch,
    setValue,
    goToNextForm,
  } = useIncludeFunctionaryForm();
  const initialPlanData = useBoostedPlanDataStore(x => x.data);
  const DependentOpenModal = useDependentOpenModalDataStore(x => x.data);
  const setDependentOpenModal = useDependentOpenModalDataStore(
    x => x.setdependentOpenModalData,
  );
  const setShow = useDependentShowStore(x => x.setdependentOpenModalData);

  const dependentes = watch(`newDependents`);
  const Id = useDependentIdStore(state => state.id);
  const setId = useDependentIdStore(state => state.setId);

  const saveDependent = async () => {
    const dependenteData = dependentes[Id];
    validateDependent(dependenteData);
    if (!validateDependent(dependenteData)) {
      handleSubmit(goToNextForm)();
      return;
    }
    if (dependenteData.cpf == '' || dependenteData.cpf == undefined) {
      const Idade = await calculaIdade(dependenteData?.dtNascimento || '');
      if (Idade > 15 && (!dependenteData.cpf || dependenteData.cpf == '')) {
        alert('Dependente com mais de 16 anos deve ter CPF.');
        return;
      }
    }
    alert('Dependente salvo com sucesso!');
    setDependentOpenModal(false);
  };
  const openModal = () => {
    setDependentOpenModal(true);
    setShow(true);

    if (
      dependentes?.length > 0 &&
      (dependentes[0].nome == '' || dependentes[0].nome == undefined)
    ) {
      setId(0);
    } else {
      setId(dependentes.length);
    }
  };

  const removeClick = (ind: number) => {
    const currentDependentes = watch('newDependents') || [];
    const updatedDependentes = currentDependentes.filter(
      (_, index) => index !== ind,
    );
    setValue('newDependents', updatedDependentes);
    if (updatedDependentes.length === 0) {
      setShow(false);
    }
  };

  const closeModal = () => {
    removeClick(Id);
    setDependentOpenModal(false);
  };
  useEffect(() => {
    setDependentOpenModal(false);
  }, []);

  return (
    <div>
      <div className="w-full relative flex min-[748px]:justify-end justify-center gap-6">
        <Button type="button" text="Adicionar Dependente" onClick={openModal} />
      </div>

      <Modal
        isOpen={DependentOpenModal}
        onRequestClose={closeModal}
        contentLabel="Formulário de Funcionário"
        className="modal"
        overlayClassName="modal-backdrop"
      >
        <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
          Dados do Dependente
        </h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <div className="min-[748px]:col-span-2">
              <Input
                label="Nome"
                placeholder="Nome"
                errorMessage={errors?.newDependents?.[Id]?.nome?.message}
                {...register(`newDependents.${Id}.nome`)}
              />
            </div>

            <Input
              activateMask
              mask="999.999.999-99"
              label="CPF"
              placeholder="CPF"
              errorMessage={errors?.newDependents?.[Id]?.cpf?.message}
              {...register(`newDependents.${Id}.cpf`)}
            />
          </div>

          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <Input
              activateMask
              mask="99/99/9999"
              label="Data de nascimento"
              placeholder="dd/mm/aaaa"
              errorMessage={errors?.newDependents?.[Id]?.dtNascimento?.message}
              {...register(`newDependents.${Id}.dtNascimento`)}
            />

            <Select
              label="Estado civil"
              placeholder="Estado civil"
              options={[]}
              optionsFull={initialPlanData.listaEstadosCivil}
              errorMessage={errors?.newDependents?.[Id]?.estCivil?.message}
              {...register(`newDependents.${Id}.estCivil`)}
            />

            <Select
              label="Gênero"
              placeholder="Gênero"
              options={[]}
              optionsFull={initialPlanData.listaSexos}
              errorMessage={errors?.newDependents?.[Id]?.sexo?.message}
              {...register(`newDependents.${Id}.sexo`)}
            />
          </div>

          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <div className="min-[748px]:col-span-2">
              <Input
                label="Nome da mãe"
                placeholder="Nome da mãe"
                errorMessage={errors?.newDependents?.[Id]?.motherName?.message}
                {...register(`newDependents.${Id}.motherName`)}
              />
            </div>

            <Select
              label="Parentesco"
              placeholder="Parentesco"
              options={[]}
              optionsFull={initialPlanData.listaParentescos}
              errorMessage={errors?.newDependents?.[Id]?.parentesco?.message}
              {...register(`newDependents.${Id}.parentesco`)}
            />
          </div>
        </form>
        <div
          style={{
            display: 'flex',
            marginTop: '25px',
            flexDirection: 'row-reverse',
          }}
        >
          <Button
            type="button"
            onClick={closeModal}
            text="Cancelar"
            style={{ background: '#CC0505' }}
          />
          <Button
            type="button"
            intent="secondary"
            Icon={SaveIcon}
            onClick={saveDependent}
            text="Salvar Dependente"
            style={{ marginRight: '20px' }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            marginTop: '25px',
            flexDirection: 'row-reverse',
          }}
        >
          <Button type="button" text="Fechar" onClick={closeModal} />
        </div>
      </Modal>
    </div>
  );
}

export default DependentForm;
